<template>
	<v-layout row wrap align-center justify-center class="content-pad-vert">
		<v-flex xs12 md7 v-if="event" class="pt-5 pl-3 pr-3">
			<div v-if="isHost">
				<v-card>
					Call us
				</v-card>
			</div>
			<div v-else>
				Not host, can't edit
			</div>
			<div v-if="false">
				<p class="add-event-step-header-big mb-2" style="font-size: 350%!important;">Edit Event</p>
				<p class="add-event-step-error mb-5" v-if="!readyToSubmit">There are one or more incomplete parts. Please review form and re-submit.</p>

				<!-- Type -->
				<p class="add-event-step-header mb-0">wrkprty type</p>
				<v-radio-group v-model="typeSelectionC" :mandatory="false" class="mt-0">
					<div v-for="(type, index) in types" :key="index">
						<v-radio :label="type.title" :value="type.value" class="mt-2 mb-1 add-event-radio-selection"></v-radio>
						<div class="add-event-radio-description">
							{{type.description}}
						</div>
					</div>
				</v-radio-group>

				<!-- Description -->
				<p class="add-event-step-header mb-0" :class="{'add-event-step-invalid': ((description === null)
				|| (title === null))}">Description</p>
				<p class="add-event-step-error mb-2" v-if="((description === null)
				|| (title === null))">Please enter a title and description</p>
				<p class="add-event-step-sub-header mb-1">Try something simple and effective.</p>
				<v-text-field :error="title === null" v-model="titleC" label="Title"></v-text-field>
				<v-textarea :error="description === null" v-model="descriptionC" label="Description"></v-textarea>

				<!-- Seating -->
				<p class="add-event-step-header mb-0" :class="{'add-event-step-invalid': ((seats === null)
				|| (price === null)
				|| (!validSeats)
				|| (!validPrice))}">Seating</p>
				<p class="add-event-step-error mb-2" v-if="((seats === null)
				|| (price === null)
				|| (!validSeats)
				|| (!validPrice))">Please enter valid seats and price</p>
				<v-text-field id="seats" :error="!validSeats" class="mb-2" :rules="[rules.seats]" v-model="seatsC" type="number" label="Number of seats"></v-text-field>
				<v-text-field id="price" :error="!validPrice" class="mb-2" :rules="[rules.price]" v-model="priceC" type="number" label="Ticket price"></v-text-field>

				<!-- Amenities -->
				<p class="add-event-step-header">Amenities</p>
				<v-layout row wrap>
					<v-flex xs12 sm12 md6 v-for="tag in getEventTags" v-if="tag.tag_type==='AMENITIES'" :key="tag.pk">
						<v-checkbox :label="tag.name" :value="tag.pk" v-model="tagsC" class="ma-0 pa-0 add-event-radio-selection"></v-checkbox>
					</v-flex>
				</v-layout>
				<p class="add-event-step-header">Location Info</p>
				<v-layout row wrap>
					<v-flex xs12 sm12 md6 v-for="tag in getEventTags" v-if="tag.tag_type==='LOCATION_INFO'" :key="tag.pk">
						<v-checkbox :label="tag.name" :value="tag.pk" v-model="tagsC" class="ma-0 pa-0 add-event-radio-selection"></v-checkbox>
					</v-flex>
				</v-layout>

				<!-- Notes -->
				<p class="add-event-step-header mb-0" :class="{'add-event-step-invalid': ((notes === null)
				|| (houseRules === null))}">Notes and rules</p>
				<p class="add-event-step-error mb-2" v-if="((notes === null)
				|| (houseRules === null))">Please enter notes and rules</p>
				<v-textarea class="ml-2 mb-2 add-event-text-box" v-model="notesC" label="Host notes"></v-textarea>
				<v-textarea class="ml-2 add-event-text-box" v-model="houseRulesC" label="House rules"></v-textarea>

				<!-- Photos -->
				<v-layout row wrap>
					<v-flex xs12 class="pa-1">
						<p class="add-event-step-header mb-0" :class="{'add-event-step-invalid': images.length < 1}">Photos</p>
						<p class="add-event-step-error mb-2" v-if="images.length < 1">You must upload at least one photo</p>
						<input 
							class="image-dropzone"
							type="file" 
							accept="image/*" 
							:multiple="true" 
							ref="fileInput"
							@change="onFilePicked"
							required
						/>
					</v-flex>
					<v-flex xs12>
						<v-card raised class="pa-1 ma-1 photo-card">
							<v-layout row wrap>
								<div class="pa-1 ma-1 photo-preview" :class="{selected: index==selecedImageIndex}" v-for="(imageUrl, index) in imageUrls" style="display:inline-block;" @click.prevent="clickImage(index)" :key="index">
									<v-flex d-flex xs12>
										<v-card>
											<v-container fill-height class="image-div pa-0">
												<v-layout row wrap align-center>
													<v-flex class="text-xs-center pa-0">
														<div>
															<img :src="imageUrl" class="image-thumb pa-0">
															<v-btn @click.prevent="removePhoto(index)" icon dark class="remove-button red"><v-icon>close</v-icon></v-btn>
															<v-chip small disabled class="primary primary-photo-chip" v-if="index==selecedImageIndex">Main Photo</v-chip>
														</div>
													</v-flex>
												</v-layout>
											</v-container>
										</v-card>
									</v-flex>
								</div>
							</v-layout>
						</v-card>
					</v-flex>
				</v-layout>
				<v-btn class="primary mt-3 mb-5">Submit Changes</v-btn>
			</div>
		</v-flex>
	</v-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { fetchEvent } from '~/store/api/event_location_api'
export default {
	data() {
		return {
			event: null,
			typeSelection: null,
			title: null,
			description: null,
			seats: null,
			price: null,
			tags: [],
			notes: null,
			houseRules: null,
			images: [],
			imageUrls: [],
			selecedImageIndex: null,
			types: [
				{
					title: 'Wrkprty',
					value: 'wrkprty',
					description: 'Host guests to facilitate focus and connection.'
				},
				{
					title: 'Wrkshop',
					value: 'wrkshop',
					description: 'This is a work shop'
				},
				{
					title: 'Mstrmnd',
					value: 'mstrmnd',
					description: 'This is smart work party'
				},
				{
					title: 'Prsnts',
					value: 'prsnts',
					description: 'This is the presentation'
				}
			],
			recurringTypes: [
				{
					title: 'One-time Event',
					value: 'one-time',
					description:
						'Host this wrkprty once.  We"ll save your event info so you can host it again in the future.'
				},
				{
					title: 'Recurring Event',
					value: 'recurring',
					description: 'Host this wrkprty recurring every week or month.'
				}
				// { title: 'Series', value: 'series', description: 'Host a series of wrkprtys that progress toward a goal.' },
			],
			startTimeError: false,
			endTimeError: false,
			validPrice: false,
			validSeats: false,
			rules: {
				startTime: value => {
					if (this.endTime !== null && value !== null) {
						let startHour = parseInt(value.split(':')[0])
						if (value[value.length - 2] === 'p') {
							if (startHour !== 12) {
								startHour += 12
							}
						}
						let endHour = parseInt(this.endTime.split(':')[0])
						if (this.endTime[this.endTime.length - 2] === 'p') {
							if (endHour !== 12) {
								endHour += 12
							}
						}
						if (endHour - startHour < 4) {
							this.startTimeError = true
							this.endTimeError = true
							return 'Your Wrkprty must be at least 4 hours'
						}
					}
					this.startTimeError = false
					this.endTimeError = false
					return true
				},
				endTime: value => {
					if (this.startTime !== null && value !== null) {
						let startHour = parseInt(this.startTime.split(':')[0])
						if (this.startTime[this.startTime.length - 2] === 'p') {
							if (startHour !== 12) {
								startHour += 12
							}
						}
						let endHour = parseInt(value.split(':')[0])
						if (value[value.length - 2] === 'p') {
							if (endHour !== 12) {
								endHour += 12
							}
						}
						if (endHour - startHour < 4) {
							this.startTimeError = true
							this.endTimeError = true
							return 'Your Wrkprty must be at least 4 hours'
						}
					}
					this.startTimeError = false
					this.endTimeError = false
					return true
				},
				price: value => {
					if (value >= 10) {
						this.validPrice = true
						return true
					}
					this.validPrice = false
					return 'Tickets must be more than $10'
				},
				seats: value => {
					if (value >= 5) {
						this.validSeats = true
						return true
					}
					this.validSeats = false
					return 'Must have at least 5 guests for a wrkprty'
				}
			},
			datePicker: false,
			timePicker: false,
			startTimes: [
				'8:00am',
				'9:00am',
				'10:00am',
				'11:00am',
				'12:00pm',
				'1:00pm',
				'2:00pm',
				'3:00pm',
				'4:00pm'
			],
			endTimes: [
				'12:00pm',
				'1:00pm',
				'2:00pm',
				'3:00pm',
				'4:00pm',
				'5:00pm',
				'6:00pm',
				'7:00pm',
				'8:00pm',
				'9:00pm',
				'10:00pm',
				'11:00pm',
				'12:00am'
			],
			removingImage: false
		}
	},
	beforeRouteEnter(to, from, next) {
		console.log('beforeRouteEnter')
		fetchEvent(to.params.id)
			.then(result => {
				next(vm => {
					vm.setEvent(result)
				})
			})
			.catch(response => {
				console.log(response)
			})
	},
	methods: {
		setEvent(event) {
			this.event = event
			this.typeSelection = event.category
			this.title = event.title
			this.description = event.description
			this.seats = event.max_attendees
			this.price = event.price
			this.tags = event.amenities
			this.notes = event.notes
			this.houseRules = event.location_rules
			this.images = [event.primary_image.id]
			this.imageUrls = [event.primary_image.image]
			for (var i = 0; i < event.additional_images.length; i++) {
				this.images.push(event.additional_images[i].id)
				this.imageUrls.push(event.additional_images[i].image)
			}
			this.selectedImageIndex = 0
		},
		...mapActions([]),
		removePhoto(index) {
			this.removingImage = true
		},
		clickImage(index) {
			if (this.removingImage === false) {
				this.selectedImageIndex = index
			} else {
				this.images.splice(index, 1)
				this.imageUrls.splice(index, 1)
				this.removingImage = false

				if (index === this.selectedImageIndex) {
					this.selectedImageIndex = 0
				} else if (index < this.selectedImageIndex) {
					this.selectedImageIndex -= 1
				}
			}
		},
		onFilePicked(event) {
			let files = event.target.files
			let tempImages = []
			for (var i = 0; i < files.length; i++) {
				let filename = files[i].name
				let fileReader = new FileReader()
				fileReader.addEventListener('load', event => {
					this.imageUrls.push(fileReader.result)
				})
				if (filename.lastIndexOf('.') <= 0) {
					return alert('Please select a valid file')
				}
				fileReader.readAsDataURL(files[i])
				tempImages.push(files[i])
			}

			// Sort images so they are in the same order as preview thumbnails
			tempImages.sort(function(a, b) {
				return a.size - b.size
			})
			this.images.push(tempImages)
		}
	},
	computed: {
		...mapGetters(['user', 'getEventTags']),
		isHost() {
			if (this.user.pk === this.event.host.user) {
				return true
			} else {
				return false
			}
		},
		typeSelectionC: {
			get() {
				return this.typeSelection
			},
			set(val) {
				this.typeSelection = val
			}
		},
		titleC: {
			get() {
				return this.title
			},
			set(val) {
				this.title = val
			}
		},
		descriptionC: {
			get() {
				return this.description
			},
			set(val) {
				this.description = val
			}
		},
		seatsC: {
			get() {
				return this.seats
			},
			set(val) {
				this.seats = val
			}
		},
		priceC: {
			get() {
				return this.price
			},
			set(val) {
				this.price = val
			}
		},
		tagsC: {
			get() {
				return this.tags
			},
			set(val) {
				this.tags = val
			}
		},
		notesC: {
			get() {
				return this.notes
			},
			set(val) {
				this.notes = val
			}
		},
		houseRulesC: {
			get() {
				return this.houseRules
			},
			set(val) {
				this.houseRules = val
			}
		},
		imagesC: {
			get() {
				return this.images
			},
			set(val) {
				this.images = val
			}
		},
		imageUrlsC: {
			get() {
				return this.imageUrls
			},
			set(val) {
				this.imageUrls = val
			}
		},
		selectedImageIndexC: {
			get() {
				return this.selectedImageIndex
			},
			set(val) {
				this.selectedImageIndex = val
			}
		},
		readyToSubmit() {
			let isReady = !(
				this.wrkprtyTypeC === null ||
				this.titleC === null ||
				this.descriptionC === null ||
				this.dateC === null ||
				this.seatsC === null ||
				this.priceC === null ||
				!this.validSeats ||
				!this.validPrice ||
				this.notesC === null ||
				this.imagesC.length < 1 ||
				this.houseRulesC === null
			)

			return isReady
		},
		enoughSeats() {
			return true
		}
	}
}
</script>
